
import React, { useEffect, useState }  from "react";
import { Brands } from "./Brands";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { setSelected } from "../store/reducers/CartReducer";
export const  BrandsPage = () => {
   const lang = useSelector((state) => state.cart.lang);
      const theme = useSelector((state) => state.cart.theme);

  const [index,setIndex] = useState(-1)

 const categories =useSelector((state) => state.cart.products);

  const [animation,setAnimation] = useState(true)

  const dispatch = useDispatch()
  useEffect(() => {
  dispatch( setSelected({select:2}))
}, []);

  const [brands,setBrands] = useState([])




  useEffect(() => {
    fetchAgents(0)
     
     }, []);
 
   
      


     const fetchAgents = async (code) => {

      setAnimation(true)
      
        try {
         axios.get(`https://dev.dawasmart.com/Api/Agents.php?code=${code}`)
         .then(res => {
           if(res.data.success === true){
       
       
        
              setBrands(res.data.products);
             setAnimation(false);
        
            
              
           }else{
             
            setBrands([])
            setAnimation(false);
           //  toast.error(`${res.data.msg}`,{duration: 1000,},)
           
                
               }  
         
       
         })
       } catch (error) { 
       
       
       throw error;}      
       
       
            }
       



   
    




  return (
    
    <section  className="min-h-screen py-[80px] ">




   
<div style={{overflowX:'auto'}} className={`${theme === 'LM' ? 'light-scrollbar' : 'dark-scrollbar' } flex min-w-[70%] gap-2 p-1 py-3`}>
<button
              
                onClick={()=>{
            
            if(index!==-1){
             setIndex(-1)
         
            
           fetchAgents(0)
            
            }
            
          //  console.log(JSON.stringify(category.products))
           }}
                className={`m-auto transition-all  duration-500  px-1 py-1  rounded-xl shrink-0  ${
                  index === -1
                    ? `  ${theme === 'LM' ? 'bg-primary text-white' : 'bg-primary_ text-[#000000]'  }  px-3  `
                    : `${theme === 'LM' ? 'bg-zinc-100' : 'bg-zinc-700'  } `
                } h-[50px] `}
              >
                 {lang === 'en' ? 'All' : 'الكل' } 
              </button>
            {categories.map((category, i) => (
              <button
                key={i}
                onClick={()=>{
            
            if(i!==index){
             setIndex(i)
        
            
           fetchAgents(category.code)
            
            }
            
          //  console.log(JSON.stringify(category.products))
           }}
                className={`m-auto transition-all  duration-500  px-1 py-1  rounded-xl shrink-0  ${
                  index === i
                    ? `  ${theme === 'LM' ? 'bg-primary text-white' : 'bg-primary_ text-[#000000]'  }   px-3 `
                    :  `${theme === 'LM' ? 'bg-zinc-100' : 'bg-zinc-700'  } `
                } h-[50px] `}
              >
                {lang === 'en' ? category.value_en : category.value }
              </button>
            ))}
          </div>
          


      
 {/* Custom <hr/> */}
 <div className="flex mt-6 max-w-full bg-zinc-300 h-[3px] w-full" />
 
      
      <div className=" w-full ">
      <div className="flex gap-2  px-10 xl:px-18 lg:px-20 xl:px-24   w-full  h-[60px] ">
          <h2 style={{fontFamily:'CairoExtraBold'}} className= {`${lang === 'en' ? 'text-left' :'text-right'} w-full  my-auto text-[20px]  lg:text-[50px]  md:text-[40px]  sm:text-[30px]  xs:text-[20px]    `} >
          { lang === 'en' ? 'Pharmacies' :'الصيدليات'} 
          </h2>
        </div>


    <Brands lang={lang} animation={animation} Brands={brands} />
          
      

        </div>
    

     
    </section>
  );
}
